import type { paths } from '@/generated/api';

export const endpoints = {
  analyticsTrackEvent: '/analytics/trackEvent',
  analyticsChallengeViewed: '/analytics/challenge-viewed',
  clientErrors: '/client-errors',
  publicChallenge: '/public/challenges/{slug}',
  startCheckout: '/public/challenges/{slug}/checkout',
  confirmCheckout: '/public/checkouts/{checkoutIntentId}/confirm',
  joinChallenge: '/challenges/{slug}/join',
  challengeFeed: '/challenges/{slug}/feed',
  myAccount: '/me/account',
  myParticipations: '/me/participations',
  recordActivity: '/me/participations/{participationId}/activities',
  myActivities: '/me/participations/{participationId}/activities',
  importHealthConnectSessions: '/me/activities/health-connect',
  importAppleHealthWorkouts: '/me/activities/apple-health',
  recordGpsOuting: '/me/activities/gps',
  associations: '/associations',
  myAssociations: '/associations/mine',
  associationHelloAssoCredentials: '/associations/{associationId}/helloasso-credentials',
  associationDonationForms: '/associations/{associationId}/donation-forms',
  associationDonationForm: '/associations/{associationId}/donation-form',
  associationChallenges: '/associations/{associationId}/challenges',
  associationChallenge: '/associations/{associationId}/challenges/{challengeId}',
} as const satisfies Record<string, keyof paths>;
